var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"data-page":_vm.page.slug,"data-layout":"services"}},_vm._l((_vm.page.sections),function(section,s){return _c(section.template,{key:s,tag:"lazy-component",staticClass:"component-section",attrs:{"data":section}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }